module.exports = __webpack_public_path__ + "img/logout.a53531b6.svg";